import request from '@/utils/request';

export function codeNumber(data) {
    return request({
        url: `/sendCode/${data}`,
        method: 'get',
    })
}

export function loginApi(data){
    return request({
        url: '/sms/login',
        method: 'post',
        data: data
    })
}